import { getCatalogue } from './catalogueClient';

export const getVersions = async (brandId, modelId, yearId, options) => {
  if (!brandId || !modelId || !yearId) return [];
  return getCatalogue('versions', [brandId, modelId, yearId], 'getVersionsV2', { brandId, modelId, yearId }, options);
};
